<br>
<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">

    <div class="flex-row" [formGroup]="form">
      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label class="purp">Filtra enti locali</mat-label>
        <input matInput [formControlName]="'descrizione'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label class="purp">Filtra Province</mat-label>
        <mat-select [formControlName]="'provincia'" appearance="fill" color='accent'>
          <mat-option value=""></mat-option>
          <mat-option value="BL">Belluno</mat-option>
          <mat-option value="PD">Padova</mat-option>
          <mat-option value="RO">Rovigo</mat-option>
          <mat-option value="TV">Treviso</mat-option>
          <mat-option value="VE">Venezia</mat-option>
          <mat-option value="VR">Verona</mat-option>
          <mat-option value="VI">Vicenza</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label class="purp">Filtra Tipologia Ente</mat-label>
        <mat-select [formControlName]="'tipologiaEnte'" appearance="fill" color='accent'>
          <mat-option value=""></mat-option>
          <mat-option value="COMUNE">Comune</mat-option>
          <mat-option value="UNIONEDIENTI">Unione di enti</mat-option>
          <mat-option value="ENTEPARCO">Ente parco</mat-option>
          <mat-option value="PROVINCIA">Provincia</mat-option>
          <mat-option value="PREFETTURAUTG">Prefettura UTG</mat-option>
          <mat-option value="CONSORZIODIBONIFICA">Consorzio di bonifica</mat-option>
          <mat-option value="VVF">VV.F.</mat-option>
          <mat-option value="ENTEVIABILITA">Ente Gestore Viabilita'</mat-option>
          <mat-option value="SOCIETAAUTOSTRADALE">Societa' Autostradale</mat-option>
          <mat-option value="ENTEINFRASTRUTTURAFERROVIARIA">Ente Gestore Infrastruttura Ferroviaria</mat-option>
          <mat-option value="ENTEGESTOREENERGIA">Ente Gestore Energia</mat-option>
          <mat-option value="SOCIETAMULTISERVIZI">Societa' Multiservizi</mat-option>
          <mat-option value="AZIENDASANITARIA">Azienda Sanitaria</mat-option>
          <mat-option value="REGIONEDELVENETO">Regione Del Veneto</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-row custom-row" [formGroup]="form">
      <mat-form-field appearance="fill" color='accent' class="searchbar">
        <mat-label class="purp">Filtra Stato Raccolta Dati</mat-label>
        <mat-select [formControlName]="'statoRaccoltaDati'" appearance="fill" color='accent'>
          <mat-option value=""></mat-option>
          <mat-option value="APE">Aperto</mat-option>
          <mat-option value="CHI">Chiuso</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Colonna "Filtra Stato Correzione Dati" nascosta -->
      <!-- PRIMA <mat-form-field appearance="fill" color='accent' class="searchbar"> -->
      <mat-form-field appearance="fill" color='accent' class="searchbar" style="display: none;">
        <mat-label class="purp">Filtra Stato Correzione Dati</mat-label>
        <mat-select [formControlName]="'statoCorrezioneDati'" appearance="fill" color='accent'>
          <mat-option value=""></mat-option>
          <mat-option value="APE">Aperto</mat-option>
          <mat-option value="CHI">Chiuso</mat-option>
        </mat-select>
      </mat-form-field>

      <section class="example-section" style="width: 230px">
      <mat-checkbox class="example-margin" [formControlName]="'abilitato'" [checked]="false" style="margin-left: -13%;">
        Solo abilitati</mat-checkbox>
      </section>
    </div>

    <mat-action-row class='colored'>
      <button mat-stroked-button color='basic' class="pers2 mleft" (click)="this.onReset()">
        RESET
      </button>
      <button mat-flat-button color='accent' class="pers3 mleft" (click)="ricercaListaEnti()">
        FILTRA
      </button>

    </mat-action-row>
  </div>

</mat-expansion-panel>


<div class="flex-row-end">
  <button mat-flat-button color='accent' class="pers3 mleft"
    (click)="openModificaStatiEnteDialog('APERACCDATI')">
    APERTURA/RIAPERTURA RACCOLTA DATI
  </button>
  <!-- Pulsante "MODIFICA DATA CHIUSURA RACCOLTA DATI" nascosto -->
  <!-- PRIMA <button *ngIf="this.sonoTuttiApertiRaccDat == 0 && isRaccoltaDati" mat-flat-button color='accent' class="pers3 mleft"-->
  <button *ngIf="false" mat-flat-button color='accent' class="pers3 mleft"
    (click)="openModificaStatiEnteDialog('DATACHIRACCDATI')">
    MODIFICA DATA CHIUSURA RACCOLTA DATI
  </button>
  <!-- Pulsante "APERTURA/RIAPERTURA CORREZIONE DATI" nascosto -->
  <!-- PRIMA <button *ngIf="this.sonoTuttiApertiCorrDat == 1 && isRaccoltaDati" mat-flat-button color='accent' class="pers3 mleft" -->
  <button *ngIf="false" mat-flat-button color='accent' class="pers3 mleft"
    (click)="openModificaStatiEnteDialog('APECORRDATI')">
    APERTURA/RIAPERTURA CORREZIONE DATI
  </button>
  <button *ngIf="this.sonoTuttiApertiCorrDat == 0 && isRaccoltaDati" mat-flat-button color='accent' class="pers3 mleft"
    (click)="openModificaStatiEnteDialog('DATACHICORRDATI')">
    MODIFICA DATA CHIUSURA CORREZIONE DATI
  </button>
</div>

<hr>

<mat-table [dataSource]="dataSource" matSort matSortActive="idEnte" matSortDirection="asc" matSortDisableClear>

  <ng-container matColumnDef="selectRaccoltaDati">
  <mat-header-cell *matHeaderCellDef>
    <mat-checkbox class="example-margin"
                  [checked]="allSelectedRaccoltaDati === 'S' ? true : false"
                  (change)="setAllRaccoltaDatiSelection($event.checked)"
                  [disabled]="(this.isDettaglio && !this.isModifica)">
    </mat-checkbox>
    Seleziona<br>Enti
  </mat-header-cell>
  <mat-cell [attr.data-label]="'Seleziona Enti'" *matCellDef="let element">
    <mat-checkbox class="example-margin"
                  (change)="setSingleRaccoltaDatiSelection(element, $event.checked)"
                  [checked]="element.selezionatoPerRaccoltaDati === 'S' ? true : false"
                  [disabled]="(this.isDettaglio && !this.isModifica)">
    </mat-checkbox>
  </mat-cell>
  </ng-container>

  <ng-container matColumnDef="nodeCode">
    <mat-header-cell *matHeaderCellDef> Codice ente </mat-header-cell>
    <mat-cell [attr.data-label]="'nodeCode'" *matCellDef="let element"> {{element.nodeCode}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="descrizione">
    <mat-header-cell *matHeaderCellDef> Ente </mat-header-cell>
    <mat-cell [attr.data-label]="'descrizione'" *matCellDef="let element"> {{element.descrizione}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stato">
    <mat-header-cell *matHeaderCellDef>Stato<br>raccolta dati</mat-header-cell>
    <mat-cell [attr.data-label]="'stato'" *matCellDef="let element">
      <span *ngIf="element.stato == 'APE'">Aperto</span>
      <span *ngIf="element.stato == 'CHI'">Chiuso</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataChiusRaccDati">
    <mat-header-cell *matHeaderCellDef>Data chiusura<br>raccolta dati</mat-header-cell>
    <mat-cell [attr.data-label]="'dataChiusRaccDati'" *matCellDef="let element">
      {{this.datePipe.transform(element.dataChiusuraRaccoltaDati, 'dd/MM/yyyy')}}
    </mat-cell>
  </ng-container>

  <!-- Colonna "Stato correzione dati" nascosta -->
  <!-- PRIMA <ng-container matColumnDef="statoCorrDati"> -->
  <ng-container matColumnDef="statoCorrDati" style="display: none;">
    <mat-header-cell *matHeaderCellDef>Stato<br>correzione dati</mat-header-cell>
    <mat-cell [attr.data-label]="'statoCorrDati'" *matCellDef="let element">
      <span *ngIf="element.statoCorrezioneDati == 'APE'">Aperto</span>
      <span *ngIf="element.statoCorrezioneDati == 'CHI'">Chiuso</span>
    </mat-cell>
  </ng-container>

  <!-- Colonna "Data chiusura correzione dati" -->
  <!-- PRIMA <ng-container matColumnDef="dataChiusCorrDati"> -->
  <ng-container matColumnDef="dataChiusCorrDati" style="display: none;">
    <mat-header-cell *matHeaderCellDef>Data chiusura<br>correzione dati</mat-header-cell>
    <mat-cell [attr.data-label]="'dataChiusCorrDati'" *matCellDef="let element">
      {{this.datePipe.transform(element.dataChiusuraCorrezioneDati, 'dd/MM/yyyy')}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="abilitato">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox class="example-margin" [checked]="allAbilitati==='S'?true : false"
        [disabled]="(this.isDettaglio && !this.isModifica) || this.utenteDgpe" (change)="setAll($event.checked)">
      </mat-checkbox>
      Abilitato
    </mat-header-cell>

    <mat-cell [attr.data-label]="'abilitazione'" *matCellDef="let element">
      <mat-checkbox class="example-margin" (change)="sendConfiguration(element)"
        [checked]="element.abilitato === 'S'? true : false"
        [disabled]="(this.isDettaglio && !this.isModifica) || (templateDistribuito === 'S' && element.abilitato === 'S' && element.editatoFE === undefined) || this.utenteDgpe">
      </mat-checkbox>

    </mat-cell>
  </ng-container>

  <!-- Colonna "Modifica stato compilazione" nascosta
  <ng-container matColumnDef="statoCompilazione">

    <mat-header-cell *matHeaderCellDef  [attr.data-label]="'Modifica stato compilazione'">
      <mat-checkbox class="example-margin" [checked]="allModStatoComp==='S'?true : false"
        (change)="setAllModStatoComp($event.checked)"
        [disabled]="(this.isDettaglio && !this.isModifica)">
      </mat-checkbox>
      Modifica stato<br>compilazione
    </mat-header-cell>

    <mat-cell [attr.data-label]="'Modifica stato compilazione'" *matCellDef="let element">
      <mat-checkbox class="example-margin" (change)="sendConfigurationModStatoComp(element)"
        [checked]="element.modificato === 'S'? true : false"
        [disabled]="(this.isDettaglio && !this.isModifica)">
      </mat-checkbox>

    </mat-cell>
  </ng-container>
  -->

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>
        Non ci sono risultati
      </h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10, 100, 300]"></mat-paginator>
